/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeScheduledTransactionPostRequest, type ProblemDetails, type ScheduledTransactionPostRequest } from '../models';
// @ts-ignore
import { AccountRequestBuilderNavigationMetadata, type AccountRequestBuilder } from './account';
// @ts-ignore
import { type WithScheduledTransactionItemRequestBuilder, WithScheduledTransactionItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { PaidRequestBuilderNavigationMetadata, type PaidRequestBuilder } from './paid';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /scheduledtransactions
 */
export interface ScheduledtransactionsRequestBuilder extends BaseRequestBuilder<ScheduledtransactionsRequestBuilder> {
    /**
     * The account property
     */
    get account(): AccountRequestBuilder;
    /**
     * The paid property
     */
    get paid(): PaidRequestBuilder;
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.scheduledtransactions.item collection
     * @param scheduledTransactionId The Guid identifier of the scheduled transaction to retrieve
     * @returns {WithScheduledTransactionItemRequestBuilder}
     */
     byScheduledTransactionId(scheduledTransactionId: Guid) : WithScheduledTransactionItemRequestBuilder;
    /**
     * Creates a scheduled transaction
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     post(body: ScheduledTransactionPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * Creates a scheduled transaction
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ScheduledTransactionPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ScheduledtransactionsRequestBuilderUriTemplate = "{+baseurl}/scheduledtransactions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ScheduledtransactionsRequestBuilderNavigationMetadata: Record<Exclude<keyof ScheduledtransactionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byScheduledTransactionId: {
        requestsMetadata: WithScheduledTransactionItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["scheduledTransactionId"],
    },
    account: {
        navigationMetadata: AccountRequestBuilderNavigationMetadata,
    },
    paid: {
        navigationMetadata: PaidRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ScheduledtransactionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ScheduledtransactionsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeScheduledTransactionPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
